<template>
    <div class="modal-content tw-text-left tw-px-6 tw-relative">
        <div class="tw-flex tw-justify-between tw-items-center tw-pb-6 tw-sticky tw-top-0 tw-left-0 tw-w-full tw-pt-6 tw-bg-white">
            <h4 class="tw-font-bold tw-text-lg">{{ $t('privacyPolicy.title') }}</h4>
            <div class="modal-close tw-cursor-pointer tw-z-50" @click="$store.dispatch('closeAllModals')">
                <svg class="tw-fill-current" xmlns="http://www.w3.org/2000/svg" width="17.639" height="17.567" viewBox="0 0 17.639 17.567"><g transform="translate(16.821 16.749) rotate(180)"><path d="M389.1,2434l7.28-7.282a.421.421,0,0,0,0-.6.425.425,0,0,0-.594,0l-7.281,7.283-7.281-7.283a.421.421,0,0,0-.595.6l7.281,7.282-7.281,7.281a.421.421,0,0,0,.6.6l7.281-7.281,7.281,7.281a.418.418,0,0,0,.3.123.421.421,0,0,0,.3-.719L389.1,2434Z" transform="translate(-380.503 -2426.001)" fill="#ccc" stroke="#ccc" stroke-width="1.5"/></g></svg>
            </div>
        </div>
        <div class="tw-max-h-3/4 tw-h-64 tw-overflow-y-auto">
            <p>Apreciamos o seu interesse nos nossos produtos e sua visita ao nosso site. A sua privacidade é importante para nós e queremos que se sinta confortável ao visitar o nosso site. A protecção dos seus dados pessoais, como número de telefone, endereço de email, nome, endereço, é uma preocupação importante à qual prestamos especial atenção.</p>
            <br>
            <p>Com base na Directiva de Protecção de Dados Europeia 95/46 / EG e 97/66 / EG (como implementado em vários Estados-Membros da União Europeia) estamos a informá-lo sobre o tratamento dos seus dados pessoais e os seus direitos em matéria de tratamento de dados pessoais.</p>
            <br>
            <p style="font-style: italic">Reservamo-nos o direito de alterar, atualizar ou corrigir esta Declaração de Privacidade ou de qualquer informação contida no site a qualquer momento sem aviso prévio, publicando uma declaração alterada no site. A utilização continuada do site significa que aceita e concorda com a Declaração de Privacidade rectificada. Se não aceitar esta Declaração de Privacidade (conforme alterada de tempos a tempos), por favor saia imediatamente do site.</p>
            <br>
            <h2>Quando é que recolhemos e processamos os seus dados pessoais?</h2>
            <br>
            <p>Ao utilizar o nosso site: quando visita o nosso site, a MiniSom localizada na Quinta da Fonte - Edifício Bartolomeu Dias (Q-44), Rua Quinta da Fonte, Lote 8, 1º Andar, 2774-518 Paço de Arcos, como o controladora de dados - processa automaticamente os dados pessoais sobre a sua visita. Estes dados podem incluir, mas não estão limitadas ao: nome de seus prestadores de serviços de internet, o site através do qual nos visita, os sites que visita e a duração da sua visita. Para mais informações sobre os cookies que a MiniSom usa quando visita o nosso site, por favor verifique a nossa Declaração de Cookies.</p>
            <br>
            <p>No que diz respeito a uma compra, registo de cliente, um inquérito ou um concurso: as informações que forneceu nestas situações serão processados pela MiniSom.</p>
            <br>
            <h2>Porque armazenamos e processamos os seus dados pessoais?</h2>
            <br>
            <p>Ao usar o nosso site: A MiniSom usa os dados armazenados para seguir as preferências dos nossos visitantes e optimiza o site em conformidade. Cabe a si, como um visitante do nosso site, se e em que medida fornece os dados pessoais e para que finalidade à MiniSom.</p>
            <br>
            <p>No que diz respeito a uma compra, registo de cliente, um inquérito ou um concurso: a MiniSom irá utilizar os dados recolhidos no curso normal das suas operações de negócio, para a administração técnica do site, satisfação do cliente e administração, pesquisas de produtos e marketing, mas apenas na medida do necessário, em cada caso específico.</p>
            <br>
            <h2>Processamento dos seus dados pessoais para marketing directo e opt-out</h2>
            <br>
            <p>Se necessário, pedimos aos nossos visitantes para nos informar se gostariam de receber mais informações sobre produtos e serviços ou não (marketing directo). Por exemplo, só vamos enviar-lhe mensagens de marketing via e-mail:</p>
            <p>Se der o seu consentimento (explícito) (opt-in), ex.: quando fornece à MiniSom as suas informações de contacto usando a opção de caixa de seleção, ou</p>
            <br>
            <p>Se já disponibilizou as suas informações de contacto à MiniSom porque comprou os nossos produtos (as suas informações de contacto, então, serão apenas para mensagens de marketing relativas a produtos ou serviços semelhantes ou relacionados com os produtos que já comprou e se tiver tido a possibilidade de opt out (opção de retirar a selecção inicial) ao fornecer as suas informações de contacto).</p>
            <br>
            <p>Por favor, note que pode informar a MiniSom a qualquer momento que não quer receber qualquer informação de marketing directo sobre os nossos produtos e serviços. Por favor, entre em contacto connosco usando as informações de contacto abaixo.</p>
            <br>
            <h2>Divulgação de dados pessoais</h2>
            <br>
            <p>A MiniSom pode compartilhar os seus dados pessoais com suas afiliadas, prestadores de serviços de terceiros, incluindo processadores de dados e parceiros de negócios no curso normal dos seus negócios.</p>
            <br>
            <p>A MiniSom pode disponibilizar as suas informações pessoais a terceiros, em conformidade com as leis e regulamentos aplicáveis. A MiniSom, também poderá divulgar as suas informações pessoais se acreditar, a seu exclusivo critério, que isso é necessário para prevenir ou diminuir quaisquer acções ilegais ou prejudiciais.</p>
            <br>
            <h2>Os seus direitos</h2>
            <br>
            <p>Se gostar de saber que tipo dados pessoais a MiniSom tem sobre si, ou se desejar actualizar ou corrigir qualquer um dos seus dados pessoais, por favor contacte-nos usando as informações de contacto abaixo e faremos o possível para actualizar e corrigir os seus dados pessoais.</p>
            <br>
            <h2>Links</h2>
            <br>
            <p>O site MiniSom pode incluir ou conter links para outros sites que não são abrangidos por esta Declaração de Privacidade. A MiniSom não é detentora de tais websites e não pode regular ou controlar qualquer terceiro, como utiliza os seus dados pessoais. A MiniSom não é responsável pelo conteúdo de tais sites ou uso dos seus dados pessoais.</p>
            <br>
            <h2>Contacto</h2>
            <br>
            <p>Minisom</p>
            <p>Quinta da Fonte - Edifício Bartolomeu Dias (Q-44)</p>
            <p>Rua Quinta da Fonte, Lote 8, 1º Andar</p>
            <p>2774-518 Paço de Arcos</p>
            <a href="mailto:apoioaocliente@amplifon.com">apoioaocliente@amplifon.com</a>
            <br>
            <br>

            <h4><b>{{ $t('privacyPolicy.dataProcessor.title') }}</b></h4>
            <p>{{ $t('privacyPolicy.dataProcessor.text', { company:company }) }}</p>
        </div>
        <div class="terms-footer tw-sticky tw-bg-white tw-bottom-0 tw-py-6">
            <button type="button" class="btn-cta terms" @click.prevent="$store.state.privacyPolicy = true; $store.state.modal.terms = false;">
                {{ $t('privacyPolicy.accept') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Terms',
    data() {
        return {
            company: process.env.VUE_APP_COMPANY,
        };
    },
};
</script>

<style lang="scss" scoped>
.terms-footer {
    .btn-cta {
        max-width: 100%;
    }
}

h2 {
    font-size: 18px;
}

p {
    font-size: 14px;
}

</style>
